export default __webpack_public_path__ + "static/media/14.bd4bbf4f.png";